import {
  useDispatch as useUntypedDispatch, // eslint-disable-line no-restricted-imports
} from 'react-redux';

import { AppDispatch } from '../state/store';

const useDispatch = () => useUntypedDispatch<AppDispatch>();

export default useDispatch;
